const ProjectIndex = () => import("@/pages/lab/project/ProjectIndex");
const ProjectWizard = () =>
  import("@/external/project-wizard/pages/ProjectWizard");
const ProjectSingle = () => import("@/pages/lab/project/ProjectSingle");
const ProjectDetail = () => import("@/pages/lab/project/ProjectDetail");
const ProjectAuditTrail = () => import("@/pages/lab/project/ProjectAuditTrail");
const ProjectAuditTrailHistory = () => import("@/pages/lab/project/ProjectAuditTrailHistory");
const ProjectEdit = () => import("@/pages/lab/project/ProjectEdit");

export class ProjectRoutes {
  constructor() {
    this.route_root = "projects";
    this.type_single = "Project";
    this.type_plural = "Projects";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            component: ProjectIndex,
            meta: { requiresAuth: true },
          },
          {
            path: "add/:step?",
            name: "Add",
            props: (route) => ({
              step: route.params.step,
              path: "/projects/add/",
            }),
            component: ProjectWizard,
            meta: { requiresAuth: true },
          },
          {
            path: ":project_id",
            component: ProjectSingle,
            children: [
              {
                path: "",
                component: ProjectDetail,
                name: this.type_single,
                meta: { requiresAuth: true },
                children: [],
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: ProjectEdit,
                meta: { requiresAuth: true },
              },
              {
                path: "audit-trail",
                name: `${this.type_single} Audit Trail`,
                component: ProjectAuditTrail,
                meta: { requiresAuth: true },
              },
              {
                path: "audit-trail-history",
                name: `${this.type_single} Audit Trail History`,
                component: ProjectAuditTrailHistory,
                meta: { requiresAuth: true },
              }
            ],
          },
        ],
      },
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
